import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesDetail = () => {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Tramitación de Posesión Efectiva',
      description: 'Gestión integral del trámite de posesión efectiva de herencias en Chile. Simplificamos el proceso legal y administrativo para que los herederos obtengan el reconocimiento legal y puedan administrar los bienes del causante.',
      features: [
        'Asesoría inicial y revisión de antecedentes',
        'Preparación y presentación de solicitud',
        'Gestión ante Registro Civil (herencias intestadas)',
        'Coordinación de trámites notariales',
        'Preparación de inventario de bienes',
        'Seguimiento hasta resolución del trámite',
        'Orientación para inscripciones posteriores',
      ],
      badge: 'Profesional',
      color: 'black',
      price: 'Desde $300.000',
      priceNote: 'El valor puede variar dependiendo del número de herederos, bienes de la herencia y gestiones necesarias.',
      howItWorks: [
        {
          step: '1',
          title: 'Contacto inicial y revisión',
          description: 'Revisamos los antecedentes del caso y la situación de la herencia',
        },
        {
          step: '2',
          title: 'Preparación y presentación',
          description: 'Preparamos y presentamos la solicitud de posesión efectiva',
        },
        {
          step: '3',
          title: 'Seguimiento del trámite',
          description: 'Seguimiento continuo hasta la resolución completa',
        },
      ],
    },
    {
      icon: 'ri-file-edit-line',
      title: 'Redacción de contratos',
      description: 'Redacción profesional de contratos para empresas y emprendedores mediante herramientas tecnológicas avanzadas y revisión por abogado responsable.',
      features: [
        'Contratos de prestación de servicios',
        'Contratos freelance',
        'Acuerdos comerciales',
        'Acuerdos de confidencialidad (NDA)',
        'Contratos de colaboración empresarial',
      ],
      badge: 'IA + Abogado',
      color: 'yellow',
      price: 'Desde $30.000',
      priceNote: 'El precio final depende del tipo de contrato y las cláusulas requeridas.',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Revisión de contratos',
      description: 'Análisis legal exhaustivo de contratos antes de firmar utilizando herramientas tecnológicas avanzadas y revisión profesional por abogado.',
      features: [
        'Identificación de riesgos legales',
        'Detección de cláusulas problemáticas',
        'Sugerencias de mejoras',
        'Análisis de términos y condiciones',
        'Reporte detallado de hallazgos',
      ],
      badge: 'IA + Abogado',
      color: 'yellow',
      price: 'Desde $20.000',
      priceNote: 'El valor puede variar según la extensión del documento y la complejidad del análisis.',
      priceBreakdown: [
        { label: 'Revisión simple', value: 'desde $20.000' },
        { label: 'Revisión detallada con informe', value: 'desde $80.000' },
        { label: 'Revisión con reunión de asesoría', value: 'desde $120.000' },
      ],
    },
    {
      icon: 'ri-building-line',
      title: 'Constitución de empresas SpA',
      description: 'Servicio completo para crear tu empresa en Chile de forma rápida y profesional.',
      features: [
        'Redacción de escritura de constitución',
        'Definición de objeto social',
        'Asesoría básica para emprendedores',
        'Gestión de trámites ante notaría',
        'Publicación en Diario Oficial',
      ],
      badge: 'Profesional',
      color: 'yellow',
      price: 'Desde $200.000',
      priceNote: '+ gastos notariales y administrativos.',
    },
    {
      icon: 'ri-trademark-line',
      title: 'Registro de marca',
      description: 'Gestión completa del registro de marca ante el Instituto Nacional de Propiedad Industrial (INAPI) en Chile.',
      features: [
        'Búsqueda preliminar de disponibilidad',
        'Presentación de solicitud ante INAPI',
        'Seguimiento del proceso completo',
        'Respuesta a observaciones',
        'Obtención del certificado de registro',
      ],
      badge: 'Profesional',
      color: 'black',
      price: 'Desde $290.000',
      priceNote: '+ tasas oficiales ante el Instituto Nacional de Propiedad Industrial.',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Modificación y gestión de sociedades',
      description: 'Bala Corp ofrece un servicio completo de modificación y gestión de sociedades, permitiendo a empresas y emprendedores realizar cambios legales de forma rápida, segura y correctamente formalizada.',
      features: [
        'Cambio de razón social',
        'Modificación de estatutos y objeto social',
        'Ingreso o salida de socios',
        'Aumento o disminución de capital',
        'Actualización de estructura societaria',
        'Inicio de actividades ante el SII',
        'Acreditación de giro y actualización tributaria',
        'Coordinación de gestiones notariales',
      ],
      badge: 'Profesional',
      color: 'yellow',
    },
    {
      icon: 'ri-file-shield-line',
      title: 'Gestiones notariales',
      description: 'Preparación de documentos para trámites notariales con coordinación profesional.',
      features: [
        'Redacción de poderes especiales',
        'Preparación de escrituras públicas',
        'Coordinación para autorización',
        'Revisión de documentos notariales',
        'Asesoría en trámites',
      ],
      badge: 'Profesional',
      color: 'black',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="space-y-16">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className={`rounded-3xl overflow-hidden shadow-xl ${
                service.color === 'yellow' ? 'bg-primary-yellow' : 'bg-black'
              }`}
            >
              <div className="grid lg:grid-cols-2 gap-8 p-8 lg:p-12">
                {/* Left - Content */}
                <div>
                  <div className="flex items-start space-x-4 mb-6">
                    <div className={`w-16 h-16 flex items-center justify-center rounded-2xl flex-shrink-0 ${
                      service.color === 'yellow' ? 'bg-black' : 'bg-primary-yellow'
                    }`}>
                      <i className={`${service.icon} text-3xl ${
                        service.color === 'yellow' ? 'text-primary-yellow' : 'text-black'
                      }`}></i>
                    </div>
                    <div>
                      <div className={`inline-block px-3 py-1 rounded-full text-xs font-bold mb-3 ${
                        service.color === 'yellow' ? 'bg-black text-primary-yellow' : 'bg-primary-yellow text-black'
                      }`}>
                        {service.badge}
                      </div>
                      <h3 className={`text-3xl lg:text-4xl font-bold ${
                        service.color === 'yellow' ? 'text-black' : 'text-white'
                      }`}>
                        {service.title}
                      </h3>
                    </div>
                  </div>

                  <p className={`text-lg leading-relaxed mb-6 ${
                    service.color === 'yellow' ? 'text-gray-dark' : 'text-gray-300'
                  }`}>
                    {service.description}
                  </p>

                  {/* Price block */}
                  {service.price && (
                    <div className={`mb-8 rounded-2xl p-5 ${
                      service.color === 'yellow' ? 'bg-black/8 border border-black/10' : 'bg-white/8 border border-white/10'
                    }`}>
                      <div className="flex items-baseline gap-2 mb-1">
                        <span className={`text-2xl font-extrabold tracking-tight ${
                          service.color === 'yellow' ? 'text-black' : 'text-primary-yellow'
                        }`}>
                          {service.price}
                        </span>
                        <span className={`text-xs font-semibold uppercase tracking-widest ${
                          service.color === 'yellow' ? 'text-black/50' : 'text-white/40'
                        }`}>
                          referencial
                        </span>
                      </div>
                      {service.priceNote && (
                        <p className={`text-sm leading-relaxed ${
                          service.color === 'yellow' ? 'text-gray-600' : 'text-gray-400'
                        }`}>
                          {service.priceNote}
                        </p>
                      )}
                      {/* Price breakdown */}
                      {service.priceBreakdown && (
                        <ul className={`mt-4 space-y-2 pt-4 border-t ${
                          service.color === 'yellow' ? 'border-black/10' : 'border-white/10'
                        }`}>
                          {service.priceBreakdown.map((item, i) => (
                            <li key={i} className="flex items-center justify-between gap-4">
                              <span className={`text-sm ${
                                service.color === 'yellow' ? 'text-gray-700' : 'text-gray-300'
                              }`}>
                                {item.label}
                              </span>
                              <span className={`text-sm font-bold whitespace-nowrap ${
                                service.color === 'yellow' ? 'text-black' : 'text-primary-yellow'
                              }`}>
                                {item.value}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  )}

                  <Link
                    to={service.title === 'Tramitación de Posesión Efectiva' ? '/posesion-efectiva' : '/contacto'}
                    className={`inline-block px-8 py-4 rounded-full font-bold transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer ${
                      service.color === 'yellow' 
                        ? 'bg-black text-primary-yellow hover:bg-gray-800' 
                        : 'bg-primary-yellow text-black hover:bg-yellow-400'
                    }`}
                  >
                    {service.title === 'Tramitación de Posesión Efectiva' 
                      ? 'Solicitar tramitación de posesión efectiva' 
                      : service.title === 'Modificación y gestión de sociedades'
                      ? 'Solicitar modificación de sociedad'
                      : 'Solicitar servicio'}
                  </Link>
                </div>

                {/* Right - Features */}
                <div className={`rounded-2xl p-8 ${
                  service.color === 'yellow' ? 'bg-white' : 'bg-white/10 backdrop-blur-sm'
                }`}>
                  <h4 className={`text-xl font-bold mb-6 ${
                    service.color === 'yellow' ? 'text-black' : 'text-white'
                  }`}>
                    Incluye:
                  </h4>
                  <ul className="space-y-4">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start space-x-3">
                        <div className="w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5 bg-primary-yellow">
                          <i className="ri-check-line text-black text-sm font-bold"></i>
                        </div>
                        <span className={`text-base ${
                          service.color === 'yellow' ? 'text-gray-dark' : 'text-white'
                        }`}>
                          {feature}
                        </span>
                      </li>
                    ))}
                  </ul>

                  {/* How it works section for Posesión Efectiva */}
                  {service.howItWorks && (
                    <div className="mt-8 pt-8 border-t border-gray-200">
                      <h4 className={`text-xl font-bold mb-6 ${
                        service.color === 'yellow' ? 'text-black' : 'text-white'
                      }`}>
                        Cómo funciona el servicio:
                      </h4>
                      <div className="space-y-4">
                        {service.howItWorks.map((step, idx) => (
                          <div key={idx} className="flex items-start space-x-3">
                            <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 font-bold ${
                              service.color === 'yellow' ? 'bg-black text-primary-yellow' : 'bg-primary-yellow text-black'
                            }`}>
                              {step.step}
                            </div>
                            <div>
                              <h5 className={`font-bold mb-1 ${
                                service.color === 'yellow' ? 'text-black' : 'text-white'
                              }`}>
                                {step.title}
                              </h5>
                              <p className={`text-sm ${
                                service.color === 'yellow' ? 'text-gray-dark' : 'text-gray-300'
                              }`}>
                                {step.description}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Pricing disclaimer note */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="mt-12 flex items-start gap-3 bg-gray-50 border border-gray-200 rounded-2xl px-6 py-5"
        >
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-information-line text-gray-400 text-lg"></i>
          </div>
          <p className="text-sm text-gray-500 leading-relaxed">
            <span className="font-semibold text-gray-700">Nota:</span> Los valores publicados son referenciales y pueden variar según la complejidad del caso y los antecedentes proporcionados.
          </p>
        </motion.div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="text-center mt-16"
        >
          <h3 className="text-3xl font-bold text-black mb-4">
            ¿No encuentras lo que buscas?
          </h3>
          <p className="text-gray-medium text-lg mb-8">
            Contáctanos y te ayudaremos con tu necesidad legal específica
          </p>
          <Link
            to="/contacto"
            className="inline-block bg-black text-white px-10 py-4 rounded-full font-bold hover:bg-gray-800 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            Contactar ahora
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesDetail;
